module.exports = __webpack_public_path__ + "img/TXT-SOCIAL-GITHUB.61f8651f.png";